<form
  [formGroup]="editPermissionGroupsForm"
  [ngClass]="{ 'was-validated': isFormSubmitted }"
>
  <div formArrayName="permissionGroups">
    <div
      class="teaser bg-lightest my-3"
      *ngFor="let groupCtrl of permissionGroupsFormArray.controls; let i = index; trackBy: trackByIndex"
      [formGroupName]="i"
    >
      <div class="d-flex flex-nowrap justify-content-between align-items-start">
        <div class="w-50">
          <base-input
            label=""
            formControlName="name"
            [isPreview]="!groupCtrl.get('isEditable')?.value"
            [isInvalid]="!!groupCtrl.get('name')?.errors"
            [errorMessage]="groupCtrl.get('name')?.errors | baseFieldValidation"
          ></base-input>
        </div>
        <base-button
          color="dark"
          icon="fa-solid fa-pen"
          *ngIf="groupCtrl.get('isEditable')?.value === false"
          [iconSize]="buttonSizes.md"
          (btnClick)="openGroupEditForm(i)"
          tooltip="action.edit"
          stateClass="pe-1"
        ></base-button>
      </div>

      <ng-container *ngIf="groupCtrl.get('isEditable')?.value">
        <base-permission-group
          [permissions]="selectedGroupPermissions"
          (selectionChange)="changePermission($event.isSelected, $event.permissionId, i, true)"
        ></base-permission-group>
        <div class="d-flex justify-content-end mt-5">
          <base-button
            (btnClick)="onGroupUpdate(i)"
            color="primary"
            label="group.save"
          ></base-button>
        </div>
      </ng-container>
    </div>
  </div>
</form>
